<template>
  <div class="field">
    <p class="label" v-if="label">{{ label }}</p>
    <input
      v-model="newValue"
      ref="input"
      :type="type"
      :size="digits"
      :placeholder="placeholder"
      :readonly="readonly"
      :class="[size, { fullwidth: isFullWidth }, { 'is-error': isError }]"
      class="input"
      @keyup.enter="$emit('keyup-enter')"
    />
    <div v-if="helpText" class="field__help">
      <span class="message message--base" v-text="helpText" />
    </div>
    <div v-if="errorText">
      <span class="message message--error" v-text="errorText" />
    </div>
  </div>
</template>

<script>
export default {
  name: "VField",


  props: {
    type: {
      type: String,
      default: "text"
    },
    digits: {
      type: String,
      default: "20"
    },
    name: {
      type: [String, Number],
      default: Math.random()
    },
    value: [String, Number],
    label: String,
    placeholder: String,
    isFullWidth: {
      type: Boolean,
      default: false
    },
    width: String,
    isError: {
      type: Boolean,
      default: false
    },
    helpText: String,
    errorText: String,
    size: {
      type: String,
      default: "md"
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },


  data() {
    return {
      newValue: this.value
    };
  },


  watch: {
    newValue(v) {
      this.$emit("input", v);
    },

    value(v) {
      this.newValue = v;
    }
  },


  methods: {
    setFocus() {
      this.$refs.input.focus();
    },

    setBlur() {
      this.$refs.input.blur();
    }
  }
};
</script>

<style lang="scss" scoped>
.field {
  margin-bottom: 20px;
  &__help {
    font-size: 13px;
  }
  .input {
    background: transparent;
    border: solid 1px $gray-border;
    box-sizing: border-box;
    border-radius: 5px;
    display: inline-block;
    &::placeholder {
      color: $gray;
    }
    &:focus {
      border-color: $gray;
    }
    &.is-error {
      border-color: $red;
      color: $red;
    }
    &.sm {
      padding: 5px 10px;
      font-size: 14px;
    }
    &.md {
      padding: 15px 20px;
    }
    &.lg {
      padding: 25px;
      font-size: 18px;
    }
    &.fullwidth {
      width: 100%;
    }
  }
  .label {
    color: $gray;
    margin-bottom: 15px;
  }
}
</style>
